<template>
  <div class="home">
	    <div class="box">	

           <table class="table is-fullwidth" v-if="loading === false && user.hours.length > 0">
               <thead>
                   <tr>
                       <th>Organisation</th>
                        <th>Date</th>
                        <th>Hours</th>
                       </tr>
                   </thead>
				   <tbody>
					   <tr v-for="row in user.hours" :key="row.id">
						   <td>{{ row.organisation_name }}</td>
						    <td>{{ row.date }}</td>
                            <td>{{ row.hours }}</td>
						   </tr>
					</tbody>
                    <tfoot>
                        <tr>
                            <td></td>
<td></td>
         <td><strong>{{ user.total_hours }}</strong></td>               </tr>

                    </tfoot>
            </table>

            <div class="notification is-warning" v-if="loading === true">Loading ...</div>
			<div class="notification is-info" v-if="loading === false && user.hours.length === 0">You have no hours recorded in the system yet.</div>

            
        </div>
		
	</div>
</template>

<script>
import AwardsMixin from '@/mixins/AwardsMixin.js';

export default {
  name: 'Home',
	mixins: [AwardsMixin],
	data: function () {
    	return {
		      organisations: [],
			  loading : true,
			  search: "",
				API_NAME: process.env.VUE_APP_API_NAME,
				accessToken: '',
                user: ''
		}
	},
	created() {
      this.getAccessToken()
        .then(() => { 
           this.getUserProfile();
		
        });
      
    },
	methods: {
		async getAccessToken() {
            this.accessToken = await this.$auth.getTokenSilently()
        },
		
		
	}
}
</script>
